import { utilBuildings } from "../../../utils/utilBuildings";
import { selectBuildingsProducingOrFinishedProductionResourceAvailable } from "../selectors/selectBuildingsProducingOrFinishedProductionResourceAvailable";
import { createPathSelectBuildingMaxLevel } from "./createPathSelectBuildingMaxLevel";
export var pathSelectBuildingProductionInProgressMaxLevelByResourceId = function (action, state$, deps) {
    return createPathSelectBuildingMaxLevel(function () {
        var state = state$.value;
        var resourceId = action.taskType.resourceId;
        var availableBuildings = selectBuildingsProducingOrFinishedProductionResourceAvailable(state, resourceId);
        return availableBuildings.filter(utilBuildings.isProducing);
    })(action, state$, deps);
};



//////////////////
// WEBPACK FOOTER
// ./src/features/show-me/path/pathSelectBuildingProductionInProgressMaxLevelByResourceId.ts
// module id = 2361
// module chunks = 3